module.exports = __webpack_public_path__ + "static/img/bg_home.bf93f75a.png";